/**
 * Simple utility to test API endpoints for debugging preview issues
 */

import { api } from '@/services/http';

export async function testApiEndpoint(endpoint: string): Promise<void> {
  try {
    await api.get(endpoint, {
      responseType: 'text',
      headers: {
        Accept: 'text/csv, text/plain, */*',
      },
    });
  } catch {
    // Debug helper: ignore request errors.
  }
}

// Make it available globally for console testing
(window as unknown as { testApiEndpoint?: typeof testApiEndpoint }).testApiEndpoint =
  testApiEndpoint;
